import * as React from "react";
import { LoaderScreen } from "@grandvisionhq/common";
import { useRedirects } from "../../../../hooks/hooks/use-redirects.js";
const RedirectionWrapper = ({ redirect, email, orderNumber }) => {
  const { redirectToLogin, redirectToConfirmation } = useRedirects({
    message: redirect.reason
  });
  React.useEffect(() => {
    const performRedirect = async () => {
      switch (redirect.page) {
        case "login": {
          redirectToLogin();
          break;
        }
        case "confirmation": {
          await redirectToConfirmation({ email, orderNumber });
          break;
        }
      }
    };
    performRedirect();
  }, [email, orderNumber, redirect, redirectToConfirmation, redirectToLogin]);
  return /* @__PURE__ */ React.createElement(LoaderScreen, null);
};
export {
  RedirectionWrapper
};
//# sourceMappingURL=RedirectionWrapper.js.map
